import { Component, Input } from '@angular/core';
import { GwrGrundstueckListEntry } from '../../core/gwr-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { TableSortModel } from '../../shared/tablesort/tableSortModel';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { ComparatorService } from '../../shared/services/comparator-service';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { LinkComponent } from '../../shared/components/link/link.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-gwr-grundstueck-table',
  templateUrl: './gwr-grundstueck-table.component.html',
  styleUrls: ['./gwr-grundstueck-table.component.scss'],
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, LinkComponent, TranslatePipe]
})
export class GwrGrundstueckTableComponent extends AbstractComponent {
  private _listLoader: ListLoader<GwrGrundstueckListEntry>;

  tableSortModel = new TableSortModel<GwrGrundstueckListEntry>('table', this.comparatorService);

  @Input()
  set listLoader(value: ListLoader<GwrGrundstueckListEntry>) {
    if (value) {
      this._listLoader = value;
    }
  }

  get listLoader(): ListLoader<GwrGrundstueckListEntry> {
    return this._listLoader;
  }

  constructor(private comparatorService: ComparatorService) {
    super();
    keysToTranslate<string>(['BetroffeneGrundstücke']);
    this.tableSortModel
      .addColumn('Nummer', (a, b) => this.comparatorService.gwrGrundstueckComparator(a, b), undefined)
      .switchSortDirection();
  }

  getQueryParams(listEntry: GwrGrundstueckListEntry) {
    const params = [];
    params['egrid'] = listEntry.egrid && listEntry.egrid.value;
    if (listEntry.grundstueckNummer) {
      params['bfs'] = listEntry.grundstueckNummer.gemeinde && listEntry.grundstueckNummer.gemeinde.bfsNummer;
      params['n1'] = listEntry.grundstueckNummer.nummer;
      params['n2'] = listEntry.grundstueckNummer.nummerZusatz;
      params['n3'] = listEntry.grundstueckNummer.nummer3;
      params['n4'] = listEntry.grundstueckNummer.nummer4;
    }
    return params;
  }
}
